import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, computed, WritableComputedRef, PropType, watch } from 'vue';
import {
    ConnectFlowModelingActions,
    ConnectFlowModelingGetters,
    ConnectFlowModelingMutations,
    ConnectFlowCustomModel,
    VueFlowNodeModel,
} from '@/types';

import { useVuelidate, Validation, ValidationArgs } from '@vuelidate/core';
import store from '@/store';
import { AdjustmentsIcon } from '@heroicons/vue/outline';
import { helpers } from '@vuelidate/validators';
import { useI18n } from 'vue-i18n';

interface ICustomFlowFormState {
    customFlow: null | ConnectFlowCustomModel;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectFlowCustom',
  props: {
    node: {
        type: Object as PropType<VueFlowNodeModel>,
        required: true,
    },
},
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = useI18n();

const props = __props;

const showForm = ref(false);

const nodeWritable: WritableComputedRef<VueFlowNodeModel> = computed({
    get: () => store.getters['flow/' + ConnectFlowModelingGetters.ELEMENT_BY_ID](props.node.id),
    set: (value: VueFlowNodeModel) => {
        store.commit('flow/' + ConnectFlowModelingMutations.UPDATE_ELEMENT, {
            idx: null,
            value,
        });
    },
});

const customFlowOptions = computed(
    () => store.getters['flow/' + ConnectFlowModelingGetters.CONNECT_FLOW_CUSTOM_OPTIONS],
);

const formState: Ref<ICustomFlowFormState> = ref({
    customFlow: null,
});

const textValidation = t('connectFlow.node.connectFlowCustom.validation');
const required = helpers.withMessage(textValidation, (value) => {
    return !!value;
});

const rules = computed<ValidationArgs<ICustomFlowFormState>>(() => {
    const r: ValidationArgs<ICustomFlowFormState> = {
        customFlow: {
            required,
        },
    };
    return r;
});

const v$: Ref<Validation<ValidationArgs<ICustomFlowFormState>>> = useVuelidate(rules, formState);

const nodeText = computed(() => {
    let text = t('connectFlow.node.connectFlowCustom.empty');
    if (nodeWritable.value.data.related) {
        text = nodeWritable.value.data.related.label;
    }
    return text;
});

const isFormCorrect = ref(true);

function removeNode() {
    store.dispatch('flow/' + ConnectFlowModelingActions.DELETE_NODE, {
        nodeId: nodeWritable.value.id,
        parentId: nodeWritable.value.parentId,
    });
}

async function onSubmit() {
    isFormCorrect.value = await v$.value.$validate();
    if (isFormCorrect.value) {
        if (formState.value.customFlow) {
            nodeWritable.value.data.related = {
                value: formState.value.customFlow.id,
                label: formState.value.customFlow.name,
            };
        }
        showForm.value = false;
        nodeWritable.value.data.hasErrors = !isFormCorrect.value;
    }
    v$.value.$reset();
}

watch([nodeWritable.value], () => {
    formState.value.customFlow = customFlowOptions.value.find(
        (customFlow: ConnectFlowCustomModel) =>
            customFlow.id == nodeWritable.value.data.related?.value,
    );

    v$.value.$validate().then((result) => {
        isFormCorrect.value = result;
        nodeWritable.value.data.hasErrors = !isFormCorrect.value;
    });
});

const __returned__ = { t, props, showForm, nodeWritable, customFlowOptions, formState, textValidation, required, rules, v$, nodeText, isFormCorrect, removeNode, onSubmit, get AdjustmentsIcon() { return AdjustmentsIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})